module.exports = fabric;